// import React from "react";
// import {
//   Container,
//   Row,
//   Col,
//   Form,
//   Button,
  
// } from "react-bootstrap"; 
// import SEISImage from "../../assets/seis-image.png";
// import SEIS1 from "../../assets/seis-updated-img-1.png";
// import SEIS2 from "../../assets/seis-updated-img-2.png";
// import SEIS3 from "../../assets/seis-updated-img-3.png";
// import SEIS4 from "../../assets/seis-updated-img-4.png";
// import SEIS5 from "../../assets/seis-updated-img-5.png";
// import SEIS6 from "../../assets/seis-updated-img-6.png";  


// export default function SEIS() {
// //    const [open, setOpen] = useState(0);
  

//   return (
//     <>
//     <div className="bg-light py-5">
    
//            <section className="bg-light">
//                   <Container>
//                     <Row className="g-4 align-items-start">
//                       {/* LEFT CONTENT */}
//                       <Col lg={8}>
//                               <div>
//                                   <h1>Service Exports from India Scheme (SEIS)</h1>

//                                   <h2>What is SEIS Scheme?</h2>
//                                   <p>Service Exports from India Scheme (SEIS) aims to promote export of services from India by providing duty credit scrips for eligible service exports. Under the scheme, service providers, located in India, would be rewarded under the SEIS scheme, for all eligible export of services from India. This scheme was first announced in the year 2015-20.</p>
                                
//                                   <h2>Service Exports from India Scheme (SEIS)</h2>
//                                   <h2>Objective</h2>
//                                   <p>Objective of Service Exports from India Scheme (SEIS) is to encourage and maximize export of notified Services from India.</p>
//                               </div>
//                         </Col>
//                                 <Col lg={4}>
//                                              <div className="p-4 shadow rounded right-form">
//                                                <Form>
//                                                  <Form.Control className="mb-3" placeholder="Name" />
//                                                  <Form.Control className="mb-3" placeholder="Email" />
//                                                  <Form.Control className="mb-3" placeholder="Phone" />
//                                                  <Form.Control className="mb-3" placeholder="Subject" />
//                                                  <Button className="w-100">Get Started</Button>
//                                                </Form>
//                                              </div>
//                                </Col>
//             </Row>                      
//                       <Row className="g-4 align-items-start">
//                           <Col lg={12} xl={12}>
//                               <div>
//                                   <h2>SEIS Scheme Eligibility</h2>
//                                   <p>(a) Service Providers of notified services, located in India, shall be rewarded under SEIS. The notified services and rates of rewards are listed in Appendix 3D. Only Services rendered in the manner as per Para 9.51(i) and Para 9.51(ii) of the policy shall be eligible. However, the service categories eligible under the scheme and the rates of reward on such services as rendered w.e.f. 1 April, 2019 to 31 March, 2020 shall be notified separately in Appendix 3X. For the services rendered w.e.f. 01 April, 2020, decision on continuation of the scheme will be taken subsequently and notified accordingly.</p>
//                                   <p>(b) Such service provider should have minimum net free foreign exchange earnings of US$15,000 in year of rendering service to be eligible for Duty Credit Scrip. For Individual Service Providers and sole proprietorship, such minimum net free foreign exchange earnings criteria would be US$10,000 in year of rendering service.seis india</p>
//                                   <p>(c) Payment in Indian Rupees for service charges earned on specified services, shall be treated as receipt in deemed foreign exchange as per guidelines of Reserve Bank of India. The list of such services is indicated in Appendix 3E.</p>
//                                   <p>(d) Net Foreign exchange earnings for the scheme are defined as under:</p>
//                                   <p>Net Foreign Exchange = Gross Earnings of Foreign Exchange minus Total expenses / payment / remittances of Foreign Exchange by the IEC holder, relating to service sector in the financial year.</p>
//                                   <p>(e) If the IEC holder is a manufacturer of goods as well as service provider, then the foreign exchange earnings and Total expenses / payment / remittances shall be taken into account for service sector only.</p>
//                                   <p>(f) In order to claim reward under the scheme, Service provider shall have to have an active IEC at the time of rendering such services for which rewards are claimed.</p>
                             
//                                   <h2>Following are the year-wise SEIS and relevant DGFT notices details: -</h2>

//                                   <img src={SEISImage} alt="SEIS1" className="img-fluid d-block mx-auto mb-3" />

//                                   <p>As per Notification No. 26/2015-2020 dated 16.09.2021, last date of Submitting applications for SEIS (for service exports rendered in FY 2018-19 and FY 2019-20) stands revised to 31st December 2021.</p>
//                                   <p>After 31.12.2021, no further applications would be allowed to be submitted and they would become timebarred. Late cut provisions shall also not be available for submitting claims at a later date.</p>
//                                   <p>As per Notification No. 29/2015-2020 dated 23.09.2021, following paras are inserted.</p>
//                                   <p>For SEIS claim for FY 2019-20, service providers of eligible services shall be entitled to Duty Credit Scrip at notified rates (as given in Appendix 3X) on net foreign exchange earned, with the total entitlement capped at Rs. 5 Crore per IEC for FY 2019-20.</p>
//                                   <p>For SEIS claim for FY 2019-20, the deadline for filing the online application as per ANF 3B shall be 31.12.2021. Provision of late cut under para 9.02 of HBP 2015-20 shall not apply of SEIS applications for FY 2019-20 and such applications shall get time-barred after 31.12.2021</p>
                              
//                                   <h2>List of eligible Services under SEIS & SEIS rate of rewards for the year 2017-18 are as under (Referral list for eligible services): -</h2>
                                  
//                                 <img src={SEIS1} alt="SEIS1" className="img-fluid d-block mx-auto mb-3" />
//                                   <img src={SEIS2} alt="SEIS2" className="img-fluid  d-block mx-auto mb-3" />
//                                     <img src={SEIS3} alt ="SEIS3" className="img-fluid d-block mx-auto mb-3" />
//                                     <img src={SEIS4} alt="SEIS4" className="img-fluid d-block mx-auto mb-3" />
//                                     <img src={SEIS5} alt="SEIS5" className="img-fluid d-block mx-auto mb-3" />
//                                     <img src={SEIS6} alt="SEIS6" className="img-fluid d-block mx-auto mb-3" />

//                                   <h2>Ineligible categories under SEIS</h2>
//                                   <p>Foreign exchange remittances other than those earned for rendering of notified services would not be counted for entitlement. Thus, other sources of foreign exchange earnings such as equity or debt participation, donations, receipts of repayment of loans etc. and any other inflow of foreign exchange, unrelated to rendering of service, would be ineligible.</p>
//                                   <p>Also please refer Annexure to Appendix – 3D as amended vide Public notice no. 45 Dated 05.12.2017 for other ineligible category of services.</p>
                              
//                                   <h2>Entitlement under SEIS</h2>
//                                   <p>Service Providers of eligible services shall be entitled to Duty Credit Scrip at notified rates (as given in Appendix 3D) on net foreign exchange earned.</p>
                              
//                                   <h2>How We Assist</h2>
//                                   <h2>We may assist you: -</h2>
//                                   <ul>
//                                       <li>To Identify and check eligibility to get the benefits under the scheme.</li>
//                                       <li>In documentation, preparation of application, Online filing of application and Coordination with Concerned Authority to get the Duty credit scrip.</li>
//                                       <li>Realization of value of the scrip in cash or assistance in utilization of the scrip for payment of Customs Duty /Excise duty/Services tax etc. as the case may be.</li>
//                                       <li>  We may also give presentation for better understanding of the scheme.</li>
//                                   </ul>

//                                   <p>For more details of the SEIS Scheme please contact our Apex Team - +91 72077 57511</p>
                              
//                                   <h2>At Apex Services What We Do</h2>
//                                   <p>Our professionals will be identifying and checking the eligibility to acquire the benefits under the scheme. Right from documentation, preparation of the application, online filing of an application to Coordination with Concerned Authority to get the Duty credit script, we do it all. We may even offer you a presentation for a better understanding of the scheme.</p>
//                               </div>
//                               </Col>
//                           </Row>
//             </Container>
//         </section>
        
//     </div>
//     </>    
//   );
// }

import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaCheckCircle,
  FaFileAlt,
  FaGlobe,
  FaList,
  FaRocket,
  FaIndustry,
  FaExclamationTriangle,
  FaHandsHelping
} from "react-icons/fa";

export default function SEIS() {
  return (
    <div className="bg-light py-5">
      <section className="bg-light">
        <Container>

          {/* TOP */}
          <Row className="g-4 align-items-start mb-4">
            <Col lg={8}>
              <h1>
                Service Exports from India Scheme (SEIS)
              </h1>

              <p>
                SEIS was introduced under the Foreign Trade Policy (2015–2020)
                to promote export of services from India by providing incentives
                based on foreign exchange earnings.
              </p>

              <p>
                Although currently discontinued, SEIS remains important for
                pending claims, corrections, and advisory services.
              </p>
            </Col>

            <Col lg={4}>
              {/* Add your right-side form */}
            </Col>
          </Row>

          {/* WHAT IS */}
          <h2 className="section-title">
            <FaFileAlt className="icon" /> What is SEIS?
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Incentives for service exporters</li>
            <li><FaCheckCircle /> Based on net foreign exchange earnings</li>
            <li><FaCheckCircle /> Rewards in duty credit scrips</li>
            <li><FaCheckCircle /> Applicable under FTP 2015–2020</li>
          </ul>

          {/* OBJECTIVE */}
          <h2 className="section-title">
            <FaGlobe className="icon" /> Objective of SEIS
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Promote global export of Indian services</li>
            <li><FaCheckCircle /> Increase foreign exchange inflow</li>
            <li><FaCheckCircle /> Improve competitiveness</li>
          </ul>

          {/* STATUS */}
          <h2 className="section-title">
            <FaExclamationTriangle className="icon" /> Current Status
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Scheme discontinued / under review</li>
            <li><FaCheckCircle /> No fresh applications allowed</li>
            <li><FaCheckCircle /> Past claims still relevant</li>
            <li><FaCheckCircle /> Advisory and correction support needed</li>
          </ul>

          {/* ELIGIBILITY */}
          <h2 className="section-title">
            <FaList className="icon" /> Eligibility
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Service providers located in India</li>
            <li><FaCheckCircle /> Earn foreign exchange</li>
            <li><FaCheckCircle /> Valid IEC required</li>
            <li><FaCheckCircle /> Minimum earnings criteria applicable</li>
          </ul>

          {/* BENEFITS */}
          <h2 className="section-title">
            <FaRocket className="icon" /> Incentives Under SEIS
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Reward rate: 3% to 7%</li>
            <li><FaCheckCircle /> Based on net forex earnings</li>
            <li><FaCheckCircle /> Transferable duty credit scrips</li>
          </ul>

          <p><strong>Formula:</strong> Net Forex = Earnings – Expenses</p>

          {/* PROCESS */}
          <h2 className="section-title">
            <FaIndustry className="icon" /> Application Process
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Apply via DGFT portal (ANF 3B)</li>
            <li><FaCheckCircle /> Submit documents</li>
            <li><FaCheckCircle /> DGFT verification</li>
            <li><FaCheckCircle /> Scrip issuance</li>
          </ul>

          {/* DOCUMENTS */}
          <h2 className="section-title">
            <FaFileAlt className="icon" /> Documents Required
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> IEC Certificate</li>
            <li><FaCheckCircle /> FIRC / BRC</li>
            <li><FaCheckCircle /> CA certified statement</li>
            <li><FaCheckCircle /> Digital Signature</li>
          </ul>

          {/* NOT ELIGIBLE */}
          <h2 className="section-title">
            <FaExclamationTriangle className="icon" /> Not Eligible
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Domestic services</li>
            <li><FaCheckCircle /> Non-service forex income</li>
            <li><FaCheckCircle /> Donations or loans</li>
            <li><FaCheckCircle /> Non-notified services</li>
          </ul>

          {/* CATEGORIES */}
          <h2 className="section-title">
            <FaGlobe className="icon" /> Eligible Service Categories
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Business & consulting services</li>
            <li><FaCheckCircle /> IT & professional services</li>
            <li><FaCheckCircle /> Media & communication</li>
            <li><FaCheckCircle /> Healthcare & education</li>
            <li><FaCheckCircle /> Tourism & hospitality</li>
            <li><FaCheckCircle /> Transport & logistics</li>
          </ul>

          {/* DEADLINE */}
          <h2 className="section-title">
            <FaExclamationTriangle className="icon" /> Important Deadlines
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Last filing deadline: 31 Dec 2021</li>
            <li><FaCheckCircle /> No new claims allowed</li>
            <li><FaCheckCircle /> Only corrections possible</li>
          </ul>

          {/* HELP */}
          <h2 className="section-title">
            <FaHandsHelping className="icon" /> How We Help You
          </h2>

          <p>
            At Apex Consultants, we help identify missed benefits, handle
            pending claims, correct errors, and maximize recovery of eligible SEIS incentives.
          </p>

          {/* WHY STILL IMPORTANT */}
          <h2 className="section-title">
            <FaGlobe className="icon" /> Why SEIS Still Matters
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Many exporters missed claims</li>
            <li><FaCheckCircle /> Rejections due to minor errors</li>
            <li><FaCheckCircle /> High recovery potential</li>
          </ul>

        </Container>
      </section>
    </div>
  );
}